import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const userConfigSelector = ({ userConfig }: ReducerState) => userConfig;
export const userConfigLoadingSelector = createSelector(
  userConfigSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
